import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, HeadContent, Outlet, Scripts, useNavigate } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { DialogPageLayout } from "@/components/DialogPageLayout";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Toaster } from "@roqua/components/ui/sonner";
import { getEndpoint } from "@/lib/endpoint";
import { useMatomoTracker } from "@/matomo/useMatomoTracker";
import { Providers } from "../components/providers";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootLayout,
  notFoundComponent: () => {
    return (
      <DialogPageLayout>
        <div>
          <header className="text-2xl font-bold">404 Not Found</header>
          <p>Deze pagina bestaat niet.</p>
        </div>
      </DialogPageLayout>
    );
  },
});

function RootLayout() {
  const navigate = useNavigate();
  const endpoint = getEndpoint();

  useMatomoTracker();

  return (
    <>
      <HeadContent />
      <ErrorBoundary>
        <Providers endpoint={endpoint}>
          <Outlet />
        </Providers>
        <Toaster offset={{ top: "88px" }} />
        {import.meta.env.DEV && <TanStackRouterDevtools />}
      </ErrorBoundary>
      <Scripts />
    </>
  );
}
